import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
String.isNullOrEmpty = function (value) {
  if (!value) return true;
  return value.replace(/\s/g, "").length == 0;
};
String.replaceNonAlphaNumerics = function (value) {
  var replaceBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
  if (!value) return true;
  return value.replace(/[^A-Za-z0-9À-ÿ]/g, replaceBy).replace(/\s+/g, replaceBy);
};
String.removeDiacritics = function (value) {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
String.getFirstLetters = function (value) {
  var isReplaceNonAlphaNumerics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var replaceNonAlphaNumericsBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : " ";
  if (isReplaceNonAlphaNumerics) {
    value = String.replaceNonAlphaNumerics(value, replaceNonAlphaNumericsBy);
  }
  return value.split(" ").reduce(function (acc, val) {
    if (val) return acc + val.toString()[0];
    return acc;
  }, "");
};
String.parseForVHtml = function (html) {
  var _this = this;
  return html.replace(/{{(.+?)}}/g, function (_, g) {
    return _this[g.trim()].value;
  });
};
String.diff = function (a, b) {
  return a.replace(b, "");
};
String.nl2br = function (value) {
  if (typeof value === "undefined" || value === null) {
    return "";
  }
  var breakTag = "<br />";
  return (value + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1" + breakTag + "$2");
};
String.prototype.shorterReference = function () {
  var reg = /(-0+)/g; //get the first -0+ in the string
  return this.replace(reg, "-");
};
String.prototype.asBool = function () {
  if (this.toLowerCase() == "false") return false;else if (this.toLocaleLowerCase() == "true") return true;else return null;
};
export default String;